import React from 'react';
import {HStack, Text, VStack} from '@tempo/core';
import {ContentType} from '@deezer/next/services/types/contentType';
import Thumbnail from '@components/Thumbnail';

type ArtistClaimDetailsProps = {
	artist: {
		id: number;
		name: string;
		imageHash: string;
		upc: string;
	};
};

const ArtistClaimDetails = ({artist}: ArtistClaimDetailsProps) => {
	const {name, upc, imageHash, id} = artist;

	return (
		<HStack spacing="spacing.m">
			<Thumbnail
				id={String(id)}
				picture={imageHash}
				type={ContentType.Artist}
				rounded={true}
				width={'32px'}
				height={'32px'}
			/>
			<VStack alignItems="initial" spacing={0}>
				<Text
					noOfLines={1}
					fontWeight="semibold"
					wordBreak="break-all"
					data-testid="artist-claim-cell-title"
				>
					{name}
				</Text>
				<Text
					noOfLines={1}
					wordBreak="break-all"
					data-testid="artist-claim-cell-upc"
				>
					{upc}
				</Text>
			</VStack>
		</HStack>
	);
};

export default ArtistClaimDetails;
